import {
    SET_OFFTIMES,
    SET_OFFTIMES_LOADING,
} from "actions/offtimes";

const initialState = {
    loading: false,
    list: [],
    error: null
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_OFFTIMES:
            return {
                ...state,
                list: action.payload,
            };
        case SET_OFFTIMES_LOADING:
            return {
                ...state,
                loading: action.payload,
            };
        default:
            return state;
    }
};

export default reducer;